module.exports = __webpack_public_path__ + "static/media/Instagram.1ca5d036.svg";